import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap';
import { t } from 'i18next';
import { BACKEND_URL_PORTAIL } from '../../config/const';
import axios from 'axios';

const LmsConnect = ({ open, setOpen,quessUsername }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const handleToggle = () => {
    setOpen(!open); // calls parent's toggle
    setErrorMsg(null); // clear errors when modal closes
  };
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const handleLogin = async () => {
    if (!username || !password) {
      setErrorMsg(t('invalidUsernamePassword'));
      return;
    }

    try {
      const dataPost={
        quessUserName:localStorage.getItem('username'),
        lmsUsername:username,
        password:password
      }
      axios
            .post(BACKEND_URL_PORTAIL + "api/checkUserInfoLms",dataPost, config)
            .then((response) => {
              if(response=="null")
              {
                setErrorMsg(t('invalidUsernamePassword'));
              }
              else {
              setOpen(false);
                setSuccessMsg(t('loginSuccess'))
                setTimeout(() => {
                  window.open(response.lienConnexionDirect, '_blank');
                }, 1000);
              }
      
               
              });

    } catch (error) {
      setErrorMsg(t('errorLogin'));
    }
  };

  return (
    <Modal isOpen={open} toggle={handleToggle} centered size="md">
       <ModalHeader className="detail-header" style={{ width: '100%' }} toggle={handleToggle}>
                <div className="modal-header-content">
                    <span className="modal-title">{t("lmsConnect")}</span>
                   
                </div>
            </ModalHeader>
      <ModalBody>
        <Form>
           <div className="mb-3">
            <p>{t("loginLmsMsg")}</p>
          </div>
          <FormGroup>
            <Label for="username">{t('username')}</Label>
            <Input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('username')}
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">{t('password')}</Label>
            <Input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('password')}
            />
          </FormGroup>
          {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
          {successMsg && <Alert color="green">{successMsg}</Alert>}
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-secondary" onClick={handleToggle}>
          {t('cancel')}
        </button>
        <button className="btn btn-primary" onClick={handleLogin}>
          {t('login')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default LmsConnect;
